import { Gem } from "lucide-react";

const META = {
  Quartz: { color: "#D4D4D8", bg: "#3F3F46" },
  Obsidian: { color: "#A1A1AA", bg: "#27272A" },
  "Lapis Lazuli": { color: "#60A5FA", bg: "#1E3A8A" },
  Jade: { color: "#34D399", bg: "#064E3B" },
  Sapphire: { color: "#38BDF8", bg: "#0C4A6E" },
  Emerald: { color: "#10B981", bg: "#064E3B" },
  Ruby: { color: "#FB7185", bg: "#881337" },
  Diamond: { color: "#E0F2FE", bg: "#155E75" },
  "Black Diamond": { color: "#FCD34D", bg: "#18181B" },
};

export const BadgeChip = ({ badge, className = "" }) => {
  if (!badge) return null;
  const m = META[badge] || META.Obsidian;
  return (
    <span data-testid="psi-badge" title={`${badge} badge — earned by your PSI level`}
      className={`inline-flex items-center gap-1.5 border px-2.5 py-1 text-[10px] font-black uppercase tracking-widest ${className}`}
      style={{ color: m.color, borderColor: `${m.color}66`, background: `${m.bg}40` }}>
      <Gem className="w-3 h-3" /> {badge}
    </span>
  );
};
